<div (capsLock)="onCapsLock($event)">
<mat-card>

  <mat-card-title>
    <div class="row">
      <button *ngIf="recover"
              matTooltip="Back to Login"
              mat-icon-button
              color="primary"
              (click)="recover = false">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1 class="fw-semibold col-12 text-center">
        <img src="../../../../assets/img/partner-portal.png"
             alt="Tonic logo"
             width="200">
        {{recover ? 'Password Reset' : ''}}
      </h1>
    </div>
  </mat-card-title>

  <form *ngIf="!recover" [formGroup]="loginForm">

      <mat-form-field appearance="outline">
          <mat-label>E-Mail</mat-label>
          <input matInput formControlName="email">
      </mat-form-field>

      <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password">
      </mat-form-field>

      <mat-error *ngIf="capsOn"
                 style="text-align:center">Caps Locked Turned on!</mat-error>

      <mat-checkbox [checked]="remember"
                    color="secondary"
                    style="text-align:center"
                    (change)="onRemember($event)">Remember Me</mat-checkbox>

      <button mat-raised-button
              color="primary"
              (click)="onLogin()"
              [disabled]="loginForm.invalid">Login</button>

      <button mat-stroked-button
              color="primary"
              (click)="onSignup()">Signup</button>

      <div class="clearfix text-center"
           style="margin-top: 4vh; margin-bottom: 4vh; text-align: center;">
        <a routerLink="#forgotForm" (click)="recover=true">Forgot your password?</a>
      </div>
  </form>

  <form id="forgotForm" *ngIf="recover" [formGroup]="forgotForm">
    <!-- <button mat-icon-button color="primary" (click)="recover = false">
      <mat-icon>arrow_back</mat-icon>
    </button> -->
    <mat-form-field appearance="outline">
      <mat-label>E-Mail</mat-label>
      <input matInput formControlName="email">
      <mat-error>Email required</mat-error>
    </mat-form-field>

    <button mat-flat-button
              color="primary"
              (click)="onReset()">Reset</button>
  </form>

  <mat-divider [inset]="true"></mat-divider>

  <mat-card-footer>© {{currentYr}} - Tonic. All rights reserved</mat-card-footer>

</mat-card>
</div>
